module.exports = __webpack_public_path__ + "img/dw-small.c17896d7.gif";